import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { TableData } from '../common/components/TableData';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import async from 'async';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../styles/AppTheme';
import { data } from '../data/AdminData.js'
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

export class Places extends Component {
  constructor(props) {
    super(props);
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.placeTypes = data.placeTypes;
    this.state = {
      inProcess: false,
      adminDialog: false,
      dialogAction: '',
      dialogTitle: '',
      name: '',
      lat: '',
      long: '',
      type: '',
      selectedItem: {},
      showDeleteError: false,
      placeDelete: '',
      fetchState: ApiHelperV2.State.LOADING,
      formFieldsValidity: {
        name: true,
        lat: true,
        long: true,
      },
      formFieldErrMsg: {
        name: '*Required',
        lat: '*Required',
        long: '*Required',
      }
    }
    this.palceFields = {
      name: {
        key: 'name',
        label: 'Title',
        type: 'text'
      },
      lat: {
        key: 'lat',
        label: 'Location latitude',
        type: 'text'
      },
      long: {
        key: 'long',
        label: 'Location longitude',
        type: 'text'
      },
      placeDelete: {
        key: 'placeDelete',
        label: 'Type DELETE',
        type: 'text'
      },
      type: {
        key: 'type',
        label: 'Select place type',
        type: 'text'
      },
    },
      this.navField = [
        {
          link: '/admin',
          title: 'Organisations',
          icon: 'account_balance'
        },
      ]
  }

  componentDidMount() {
    this.fetchItems();
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    const thisObj = this;
    async.parallel(
      [
        function (callback) {
          ApiHelperV2.call(
            { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['placesByOrgId'], { orgId: thisObj.slug }) }, callback)
        },
        function (callback) {
          ApiHelperV2.call(
            { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['orgs', thisObj.slug]) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          placeData: results[0],
          orgData: results[1],
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }


  add = () => {
    this.setState({
      adminDialog: true,
      dialogAction: 'add',
      dialogTitle: 'Add place',
      selectedItem: {},
      name: '',
      lat: '',
      long: '',
      type: ''
    })
  }

  edit = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'edit',
      dialogTitle: 'Edit place',
      selectedItem: item,
      name: item.name,
      lat: item.loc[0],
      long: item.loc[1],
      type: item.type
    })
  }

  delete = (item) => {
    this.setState({
      adminDialog: true,
      dialogAction: 'delete',
      dialogTitle: 'Delete place',
      selectedItem: item,
      name: item.name,
      lat: item.loc[0],
      long: item.loc[1],
      type: item.type
    })
  }

  cams = (item) => {
    this.props.history.push({
      pathname: '/admin/places/' + item._id + '/cams',
      state: { item: item, org: this.state.orgData }
    })
  }

  dialogCloseValidation = () => {
    const formFieldsValidity = this.state.formFieldsValidity;
    formFieldsValidity.name = true;
    formFieldsValidity.lat = true;
    formFieldsValidity.long = true;

    this.setState({
      formFieldsValidity: formFieldsValidity
    });
  }

  dialogClose = () => {
    const apiBody = this.dialogCloseValidation()
    this.setState({
      adminDialog: false,
      inProcess: false,
      errMsg: '',
      dialogAction: '',
      dialogTitle: '',
      selectedItem: null,
      name: '',
      lat: '',
      long: '',
      type: '',
      showDeleteError: false
    })
  }

  change = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  getFieldErrorMsg = (formFieldKey) => {
    if (this.state.formFieldErrMsg[formFieldKey]) {
      return this.state.formFieldErrMsg[formFieldKey]
    }
    return '*Required'
  }

  generateTextField = (formField, data) => {
    let disabled = ''
    let validity = {};
    validity = this.state.formFieldsValidity;

    if (this.state.dialogAction === 'delete') {
      if (formField.key === 'placeDelete') {
        disabled = false
      } else {
        disabled = true
      }
    } else {
      disabled = false
    }

    return (
      <TextField
        id={formField.key}
        label={formField.label}
        name={formField.key}
        className={css(Styles.inputCss)}
        value={data}
        onChange={e => this.change(e)}
        margin='normal'
        type={formField.type}
        helperText={this.state.dialogAction === 'delete' ? '' :
          validity[formField.key] ? '' : this.getFieldErrorMsg(formField.key)}
        error={this.state.dialogAction === 'delete' ? '' : !validity[formField.key]}
        disabled={disabled}
        InputProps={{
          classes: {
            root: css(Styles.textFieldContentInput),
          }
        }}
        InputLabelProps={{
          classes: {
            root: css(Styles.textFieldContent),
            focused: css(Styles.focused),
          }
        }}
      />
    )
  }

  generateSelectField = (formField, data) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <FormControl className={css(Styles.selectInnerContainer)}>
          <InputLabel>{formField.label}</InputLabel>
          <Select
            name={formField.key}
            value={this.state[formField.key]}
            onChange={this.onSelect}
          >
            {data.map(item => {
              return (
                <MenuItem value={item.key}>{item.name}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }

  onSelect = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  validateFields = () => {
    const item = this.state;
    const formFieldsValidity = this.state.formFieldsValidity;
    if (!item.name || item.name.length === 0) {
      formFieldsValidity.name = false;
    } else {
      formFieldsValidity.name = true;
    }
    if (!item.lat || item.lat.length === 0) {
      formFieldsValidity.lat = false;
    } else {
      formFieldsValidity.lat = true;
    }
    if (!item.long || item.long.length === 0) {
      formFieldsValidity.long = false;
    } else {
      formFieldsValidity.long = true;
    }

    this.setState({
      formFieldsValidity: formFieldsValidity
    });

    for (const key in formFieldsValidity) {
      if (formFieldsValidity[key] === false) {
        return false
      }
    }

    const apiBody = {
      name: item.name,
      lat: item.lat,
      long: item.long,
      type: item.type
    }
    return apiBody;
  }

  submitOrg = (id) => {
    const apiBody = this.validateFields();
    let options = {};
    if (apiBody) {
      this.setState({
        inProcess: true
      })

      const payload = {
        placeData: {
          name: this.state.name,
          loc: [this.state.long, this.state.lat],
          orgId: this.slug,
        }
      }
      if (this.state.type && this.state.type.length > 0) {
        payload.placeData.type = this.state.type
      }
      if (!id) {
        options = {
          method: 'POST',
          endPoint: ApiHelperV2.makeUrlPath(['places']),
          jsonBody: payload
        }
      } else {
        options = {
          method: 'PUT',
          endPoint: ApiHelperV2.makeUrlPath(['places', id]),
          jsonBody: payload
        }
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            long: '',
            lat: '',
            type: ''
          }), () => this.fetchItems());
        }
      }.bind(this))
    }
  }

  deleteOrg = (id) => {
    if (this.state.placeDelete === 'DELETE') {
      this.setState({
        inProcess: true
      })
      const options = {
        method: 'DELETE',
        endPoint: ApiHelperV2.makeUrlPath(['places', id]),
      }
      ApiHelperV2.call(options, function (err, data) {
        if (err) {
          const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
          this.setState({
            errMsg: msg,
            errCode: err.respCode,
            inProcess: false,
          })
          return
        } else {
          this.setState(state => ({
            adminDialog: false,
            inProcess: false,
            errMsg: '',
            dialogAction: '',
            dialogTitle: '',
            selectedItem: null,
            name: '',
            long: '',
            lat: '',
            type: '',
            showDeleteError: false,
          }), () => this.fetchItems());
        }
      }.bind(this))
    } else {
      this.setState({ showDeleteError: true })
    }
  }

  renderDialog = (dialogAction, title) => {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.adminDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>{title}</p>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.generateTextField(this.palceFields.name, this.state.name)}
            {this.generateTextField(this.palceFields.lat, this.state.lat)}
            {this.generateTextField(this.palceFields.long, this.state.long)}
            {this.generateSelectField(this.palceFields.type, this.placeTypes)}
          </div>
          {dialogAction === 'delete' &&
            <div className={css(Styles.fieldsContainer)}>
              {this.generateTextField(this.palceFields.placeDelete)}
            </div>
          }
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <Button
            disabled={this.state.inProcess}
            variant='contained'
            onClick={this.state.dialogAction === 'delete' ? e => this.deleteOrg(this.state.selectedItem._id) :
              e => this.submitOrg(this.state.selectedItem._id)}
            className={css(Styles.actionButton)}>
            {this.state.dialogAction === 'delete' ? 'Delete' : 'Submit'}
            {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(CommonStyles.marginLeft)} />}
          </Button>
          <Button
            variant='contained'
            onClick={() => this.dialogClose()}
            className={css(Styles.actionButton)}>
            Cancel
          </Button>
        </DialogActions>
        {this.state.showDeleteError && this.state.dialogAction === 'delete' &&
          <p className={css(Styles.deleteMsg)}>*Enter DELETE Correctly</p>
        }
        {this.state.errMsg &&
          <p className={css(Styles.deleteMsg)}>{this.state.errMsg}</p>
        }
      </Dialog>
    );
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div className={css(Styles.navOuterContainer)}>
          {this.navField.map(nav => {
            return (
              <Link to={{ pathname: nav.link }} className={css(Styles.navLink)}>
                <Icon className={css(Styles.navIcon)} color='secondary' >
                  {nav.icon}
                </Icon>
                <p className={css(Styles.navTitle)}>{nav.title}</p>
              </Link>
            )
          })}
          {this.state.orgData &&
            <p className={css(Styles.navSelected)}>{this.state.orgData.name}</p>
          }
        </div>
        <TableData
          titleIcon='location_city'
          titleText='PLACES'
          columnTitle={['Place ID', 'Title']}
          tableData={this.state.placeData}
          icons={[
            {
              title: 'create',
              funcName: 'editFunction'
            },
            {
              title: 'delete',
              funcName: 'deleteFunction'
            },
            {
              title: 'videocam',
              funcName: 'camsFunction'
            },
          ]}
          addFunction={this.add}
          editFunction={this.edit}
          deleteFunction={this.delete}
          camsFunction={this.cams}
        />
        {this.renderDialog(this.state.dialogAction, this.state.dialogTitle)}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
  },
  navOuterContainer: {
    display: 'flex',
    marginBottom: 20
  },
  navLink: {
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: AppTheme.secondaryBg,
    marginRight: 10,
    padding: 5
  },
  navIcon: {
    marginRight: 5,
    fontSize: 35
  },
  navTitle: {
    fontWeight: 600,
    fontSize: 18,
    margin: 0
  },
  navSelected: {
    fontWeight: 'bolder',
    fontSize: 20,
    margin: 0,
    marginLeft: 10,
    alignItems: 'center',
    display: 'flex'
  },
  inputCss: {
    margin: '5px 0px 10px 0px',
    flex: 1,
    color: '#757575'
  },
  dialog: {
    minWidth: 500,
    '@media(max-width: 767px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    borderBottom: '2px solid whitesmoke',
    padding: 20,
    backgroundColor: '#303E8A',
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 25,
    margin: 0,
    color: 'white'
  },
  dialogContent: {
    padding: '0px 20px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 5,
    fontSize: 16,
    textTransform: 'unset'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  textFieldContent: {
    color: '#757575',
  },
  focused: {
    color: '#3F51B5',
    fontWeight: 'bold'
  },
  deleteMsg: {
    margin: 20,
    marginTop: 0,
    fontWeight: 'bold',
    color: 'red',
    fontSize: 15
  },
  selectInnerContainer: {
    width: '100%',
    margin: '5px 0px 10px 0px',
    color: '#757575'
  }
})



// WEBPACK FOOTER //
// ./src/screens/Places.js